import { Job } from './Job'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { loadAirImportJobRelated, toInsure } from '@/api/AirImport/aiBooking'

export class AirImportJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AirImportJob'
  }
  get master() {
    return this._data.master
  }

  set master(master) {
    this._data.master = master
  }

  get hbl() {
    return this._data.hbl
  }
  set hbl(hbl) {
    this._data.hbl = hbl || ''
  }
  get operateType() {
    return this._data.operateType
  }
  set operateType(operateType) {
    this._data.operateType = operateType || 0
  }
  get freightTerm() {
    return this._data.freightTerm
  }
  set freightTerm(freightTerm) {
    this._data.freightTerm = freightTerm || ''
  }
  get releaseTypeMbl() {
    return this._data.releaseTypeMbl
  }
  set releaseTypeMbl(releaseTypeMbl) {
    this._data.releaseTypeMbl = releaseTypeMbl || 0
  }
  get releaseTypeHbl() {
    return this._data.releaseTypeHbl
  }
  set releaseTypeHbl(releaseTypeHbl) {
    this._data.releaseTypeHbl = releaseTypeHbl || 0
  }
  get loadingAgentId() {
    return this._data.loadingAgentId
  }
  set loadingAgentId(loadingAgentId) {
    this._data.loadingAgentId = loadingAgentId || 0
  }
  get groundAgentId() {
    return this._data.groundAgentId
  }
  set groundAgentId(groundAgentId) {
    this._data.groundAgentId = groundAgentId || 0
  }
  get customs() {
    return this._data.customs
  }
  set customs(customs) {
    this._data.customs = customs || false
  }
  get transDate() {
    return this._data.transDate
  }
  set transDate(transDate) {
    this._data.transDate = transDate
  }
  get releaseDate() {
    return this._data.releaseDate
  }
  set releaseDate(releaseDate) {
    this._data.releaseDate = releaseDate
  }
  get deliverDate() {
    return this._data.deliverDate
  }
  set deliverDate(deliverDate) {
    this._data.deliverDate = deliverDate
  }
  get arriveStorageDate() {
    return this._data.arriveStorageDate
  }
  set arriveStorageDate(arriveStorageDate) {
    this._data.arriveStorageDate = arriveStorageDate
  }
  get customsHBL() {
    return this._data.customsHBL
  }
  set customsHBL(customsHBL) {
    this._data.customsHBL = customsHBL || ''
  }
  get deliverRemarks() {
    return this._data.deliverRemarks
  }
  set deliverRemarks(deliverRemarks) {
    this._data.deliverRemarks = deliverRemarks || ''
  }
  get arriveStorageRemarks() {
    return this._data.arriveStorageRemarks
  }
  set arriveStorageRemarks(arriveStorageRemarks) {
    this._data.arriveStorageRemarks = arriveStorageRemarks || ''
  }
  get loadingPortOp() {
    return this._data.loadingPortOp
  }
  set loadingPortOp(loadingPortOp) {
    this._data.loadingPortOp = loadingPortOp || 0
  }
  get destinationPortOp() {
    return this._data.destinationPortOp
  }
  set destinationPortOp(destinationPortOp) {
    this._data.destinationPortOp = destinationPortOp || 0
  }
  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm || ''
  }
  get subTenantId() {
    return this._data.subTenantId
  }
  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId || 0
  }
  get airCargoDoc() {
    return this._data.airCargoDoc
  }
  set airCargoDoc(airCargoDoc) {
    this._data.airCargoDoc = airCargoDoc
  }

  get customClaim() {
    return this._data.customClaim
  }
  set customClaim(customClaim) {
    this._data.customClaim = customClaim || -1
  }

  // 加载空进Job的关联实体信息
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (key !== 'job' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadAirImportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }
  // 加载空进Job的关联实体信息 删除needLoad判断
  async loadJobRelated2(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    await loadAirImportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }
  async getAirCargoDoc() {
    const data = this._data
    if (typeof data.airCargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'airCargoDoc': true })
      } else {
        if (data.cargoDoc) {
          data.airCargoDoc = data.cargoDoc
        } else {
          data.airCargoDoc = data.cargoDoc = []
        }
      }
    }
    return data.airCargoDoc
  }
  async getCargoDoc(type, create) {
    if (this.airCargoDoc == null && !create) {
      return null
    }
    await this.getAirCargoDoc()
    if (this.airCargoDoc) {
      for (const doc of this.airCargoDoc) {
        if (doc.docType === type) {
          return doc
        }
      }
    }
    if (!create) {
      return null
    }
    const cargoDoc = new AirCargoDoc().newCargoDoc(this, type)
    cargoDoc.signByCarrier = ''
    cargoDoc.signByShipper = ''
    return cargoDoc
  }
  // 投保
  static async toInsure(job, office) {
    return await toInsure({ job, office }).then(res => res.data)
  }
}
